var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Modal',{attrs:{"title":"家庭成员信息"},on:{"on-ok":_vm.confirm},model:{value:(_vm.showModal),callback:function ($$v) {_vm.showModal=$$v},expression:"showModal"}},[_c('ModalLayout',[_c('FormLayout',{ref:"repeatInfo",staticClass:"iv-p-b-20 iv-p-l-20 iv-p-r-20",attrs:{"model":_vm.personInfo,"list":_vm.personForm}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }